module.exports = __webpack_public_path__ + "img/educabinh_icon.652e05d1.png";